import formTypes from "./form.types";

export const SetFormPeriod = period => ({
    type: formTypes.SET_PERIOD,
    payload: period
});
export const SetFormPortal = portal => ({
    type: formTypes.SET_PORTAL,
    payload: portal
});
export const SetHoldOverForm = Form => ({
    type: formTypes.SET_HOLD_OVER,
    payload: Form
});
export const ModifyLastPrice = (Price) => ({
    type: formTypes.MODIFY_LAST_PRICE,
    payload: Price
});
export const SetReceivedForm = (Form) => ({
    type: formTypes.SET_RECEIVED_FORM,
    payload: Form
});
export const SetReceivedExcel = (href) => ({
    type: formTypes.SET_RECEIVED_EXCEL,
    payload: href
});